import { render, staticRenderFns } from "./OffersSection.vue?vue&type=template&id=132c74dd&"
import script from "./OffersSection.vue?vue&type=script&lang=js&"
export * from "./OffersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports